// removed by extract-text-webpack-plugin
module.exports = {"card":"styles__card___59saW","icon":"styles__icon___3m9p8"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/Card/styles.css
// module id = 1202
// module chunks = 0